((app, ng) => {

    app.service("fileViewerModalService",
        [
            "$q", "$mdDialog", "directoryApi", function ($q, $mdDialog, directoryApi) {
                const defaults = {
                    focusOnOpen: false,
                    templateUrl: "/App/Client/FileViewer/fileviewer-template.html",
                    controller: "clientFileViewerController",
                    controllerAs: "$ctrl",
                };

                this.openPlanningDirectory = (caseId, user, client, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        locals: {
                            user,
                            client,
                        },
                        resolve: {
                            dirShortcut: [function () {
                                return directoryApi.getPlanningDirectory(caseId).then(root => {
                                    const promises = [
                                        directoryApi.getChildren(root.Id),
                                        directoryApi.getFiles(root.Id),
                                    ];

                                    return $q.all(promises).then(responses => {
                                        [root.Children, root.Files] = responses;
                                        root.DisplayChildren = true;

                                        return root;
                                    });
                                });
                            }]
                        }
                    });  

                    return $mdDialog.show(alert);
                };

                this.openInsuranceAccountDirectory = (accountId, user, client, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        locals: {
                            user,
                            client,
                        },
                        resolve: {
                            dirShortcut: [
                                function () {
                                    return directoryApi.getInsuranceAccountDirectory(accountId).then(root => {
                                        const promises = [
                                            directoryApi.getChildren(root.Id),
                                            directoryApi.getFiles(root.Id),
                                        ];

                                        return $q.all(promises).then(responses => {
                                            [root.Children, root.Files] = responses;
                                            root.DisplayChildren = true;

                                            return root;
                                        });
                                    });
                                }
                            ]
                        }
                    });

                    return $mdDialog.show(alert);
                }

                this.openInvestmentAccountDirectory = (accountId, user, client, $event) => {
                    const alert = $mdDialog.alert({
                        ...defaults,
                        targetEvent: $event,
                        locals: {
                            user,
                            client,
                        },
                        resolve: {
                            dirShortcut: [
                                function () {
                                    return directoryApi.getInvestmentAccountDirectory(accountId).then(root => {
                                        const promises = [
                                            directoryApi.getChildren(root.Id),
                                            directoryApi.getFiles(root.Id),
                                        ];

                                        return $q.all(promises).then(responses => {
                                            [root.Children, root.Files] = responses;
                                            root.DisplayChildren = true;

                                            return root;
                                        });
                                    });
                                }
                            ]
                        }
                    });

                    return $mdDialog.show(alert);
                }
            }
        ]);

})(window.app, window.angular);